<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00001">
<h2 class="nobreak">CONTENTS</h2>
</div>
<table class="calibre13" summary="">
<tbody class="calibre14"><tr class="calibre15"><td class="tdr"><span class="allsmcap">CHAPTER</span></td>
<td class="tdr" colspan="2"><span class="allsmcap">PAGE</span></td>
</tr>
<tr class="calibre15"><td class="tdr">I.</td>
<td class="calibre16"> <span class="smcap1">The Coming of Betsy</span></td>
<td class="tdr"><a href="#/Text/Section0005">      1</a></td>
</tr>
<tr class="calibre15"><td class="tdr">II.</td>
<td class="calibre16"> <span class="smcap1">The New Surroundings</span></td>
<td class="tdr"><a href="#/Text/Section0006#Page_10">      10</a></td>
</tr>
<tr class="calibre15"><td class="tdr">III.</td>
<td class="calibre16"> <span class="smcap1">The Coming of the Prince</span></td>
<td class="tdr"><a href="#/Text/Section0006#Page_22">      22</a></td>
</tr>
<tr class="calibre15"><td class="tdr">IV.</td>
<td class="calibre16"> <span class="smcap1">Betsy Meets Van</span></td>
<td class="tdr"><a href="#/Text/Section0007#Page_36">      36</a></td>
</tr>
<tr class="calibre15"><td class="tdr">V.</td>
<td class="calibre16"> <span class="smcap1">Van’s First Lessons</span></td>
<td class="tdr"><span href="#/Text/Section0008#Page_47" title="Link target outside of Sample">      47</span></td>
</tr>
<tr class="calibre15"><td class="tdr">VI.</td>
<td class="calibre16"> <span class="smcap1">Betsy’s First Lessons</span></td>
<td class="tdr"><span href="#/Text/Section0010#Page_62" title="Link target outside of Sample">      62</span></td>
</tr>
<tr class="calibre15"><td class="tdr">VII.</td>
<td class="calibre16"> <span class="smcap1">Van Goes to Church</span></td>
<td class="tdr"><span href="#/Text/Section0010#Page_74" title="Link target outside of Sample">      74</span></td>
</tr>
<tr class="calibre15"><td class="tdr">VIII.</td>
<td class="calibre16"> <span class="smcap1">The Great Storm</span></td>
<td class="tdr"><span href="#/Text/Section0012#Page_87" title="Link target outside of Sample">      87</span></td>
</tr>
<tr class="calibre15"><td class="tdr">IX.</td>
<td class="calibre16"> <span class="smcap1">More Lessons</span></td>
<td class="tdr"><span href="#/Text/Section0012#Page_100" title="Link target outside of Sample">      100</span></td>
</tr>
<tr class="calibre15"><td class="tdr">X.</td>
<td class="calibre16"> <span class="smcap1">Van’s Wild Oats</span></td>
<td class="tdr"><span href="#/Text/Section0014#Page_113" title="Link target outside of Sample">      113</span></td>
</tr>
<tr class="calibre15"><td class="tdr">XI.</td>
<td class="calibre16"> <span class="smcap1">Van Becomes a Hero</span></td>
<td class="tdr"><span href="#/Text/Section0014#Page_128" title="Link target outside of Sample">      128</span></td>
</tr>
<tr class="calibre15"><td class="tdr">XII.</td>
<td class="calibre16"> <span class="smcap1">The Great Parade</span></td>
<td class="tdr"><span href="#/Text/Section0016#Page_143" title="Link target outside of Sample">      143</span></td>
</tr>
<tr class="calibre15"><td class="tdr">XIII.</td>
<td class="calibre16"> <span class="smcap1">Van in Disgrace</span></td>
<td class="tdr"><span href="#/Text/Section0016#Page_156" title="Link target outside of Sample">      156</span></td>
</tr>
<tr class="calibre15"><td class="tdr">XIV.</td>
<td class="calibre16"> <span class="smcap1">Van’s Banishment</span></td>
<td class="tdr"><span href="#/Text/Section0018#Page_171" title="Link target outside of Sample">      171</span></td>
</tr>
<tr class="calibre15"><td class="tdr">XV.</td>
<td class="calibre16"> <span class="smcap1">Van’s Hard Lessons</span></td>
<td class="tdr"><span href="#/Text/Section0018#Page_183" title="Link target outside of Sample">      183</span></td>
</tr>
<tr class="calibre15"><td class="tdr">XVI.</td>
<td class="calibre16"> <span class="smcap1">The Journey Home</span></td>
<td class="tdr"><span href="#/Text/Section0020#Page_193" title="Link target outside of Sample">      193</span></td>
</tr>
<tr class="calibre15"><td class="tdr">XVII.</td>
<td class="calibre16"> <span class="smcap1">Van the Rescuer</span></td>
<td class="tdr"><span href="#/Text/Section0020#Page_210" title="Link target outside of Sample">      210</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?de12355e